import styled from 'styled-components';

export const ModalTypeContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
